import deepEqual from 'deep-equal';
import mapper from 'object-mapper';
import { truncate, calculate as calc, bNumber } from './Decimal';

export const isSearchConditionEmpty = (v, defaultValue = {}) => {
  if (v === undefined || v === null || v === '') {
    return true;
  }
  // if (Object.keys(v).length < 20) {
  //   return true;
  // }
  const initObj = {
    account: '',
    arrangement: '',
    booking_date: '',
    code: 'utf-8',
    department_id: '',
    departure_date: '',
    destination: '',
    dividers_id: '2',
    groups_no: '',
    is_click_farm: '0',
    is_shipment: '',
    name: '',
    ordersn: '',
    product_name: '',
    profit_margin: '',
    saler_id: '',
    seller_flag: '',
    status: '',
    supplier_id: '',
    type: 'search',
    web_source: '',
    wj: '',
  };
  defaultValue = Object.assign(initObj, defaultValue);
  // console.log(v, defaultValue);
  return deepEqual(v, defaultValue);
};

export const tbExtractMessage = (buyerMessage) => {
  if (buyerMessage === undefined || typeof buyerMessage === 'undefined' || buyerMessage === null) {
    return { 'orders_info': [] };
  }
  var reg =
    /(sim卡[:：]|联系人[:：]|电话[:：]|预订人[:：]|护照号[:：]|邮箱[:：]|出行日期[:：]|备注[:：]|泰国号码[:：]|微信号[:：]|销售[:：])([\s]*[^\s\|]+)/g;
  var result = buyerMessage.match(reg);
  var orders = {};
  var orderInfo = [];
  var isDate = function (d) {
    var regx = /^(\d{4})-(\d{2})-(\d{2})$/;
    if (!regx.test(d)) {
      return false;
    } else {
      return true;
    }
  };
  for (var xx in result) {
    if (result.hasOwnProperty(xx)) {
      var item = result[xx].split(/[：,:]/);
      item[0] = item[0].replace(/(^\s*)|(\s*$)/g, '');
      switch (
        item[0] // 按需添加
      ) {
        case 'sim卡':
          orders.simcard = item[1]; // 该字段还未计划
          break;
        case '联系人':
          orders.name = item[1];
          break;
        case '电话':
          orders.phone = item[1];
          break;
        case '邮箱':
          orders.email = item[1];
          break;
        case '出行日期':
          item[1] = item[1].substr(0, 10);
          item[1] = isDate(item[1]) ? item[1] : null;
          orderInfo.push({ 'departure_date': item[1] });
          break;
        case '备注':
          orders.remark = item[1];
          break;
        case '销售':
          orders.saler = item[1];
          break;
        default:
      }
    }
  }
  orders.orders_info = orderInfo;
  return orders;
};

export const costCalculate = (per_price = 0, num = 0, d_price = 0) => {
  let tmpTotalprice = calc(`${bNumber(per_price)} * ${num}`);
  if (num % 2 === 1) {
    tmpTotalprice = calc(`${tmpTotalprice} + ${bNumber(d_price)}`);
  }
  return tmpTotalprice;
};

export const webSettlementCalculate = (total_fee = 0, cost_calculate = 0, commission_rate = 0, total_insurance = 0) => {
  console.log(
    'webSettlementCalculate',
    `${bNumber(total_fee)} - (${bNumber(total_fee)} * ${bNumber(commission_rate)}) - ${bNumber(
      cost_calculate
    )} - ${bNumber(total_insurance)}`
  );
  return calc(
    `${bNumber(total_fee)} - (${bNumber(total_fee)} * ${bNumber(commission_rate)}) - ${bNumber(
      cost_calculate
    )} - ${bNumber(total_insurance)}`
  );
};

export const stateTB = (str) => {
  //['完整状态名称', '简称']
  if (str === '' || str === undefined || str === null) {
    return ['', ''];
  }
  const states = {
    'TRADE_NO_CREATE_PAY': ['没有创建支付宝交易', '没有创建交易'],
    'WAIT_BUYER_PAY': ['等待买家付款', '等待买家付款'],
    'WAIT_SELLER_SEND_GOODS': ['等待卖家发货，即:买家已付款', '等待卖家发货'],
    'WAIT_BUYER_CONFIRM_GOODS': ['等待买家确认收货，即:卖家已发货', '等待确认收货'],
    'TRADE_BUYER_SIGNED': ['买家已签收,货到付款专用', '买家已签收'],
    'TRADE_FINISHED': ['交易成功', '交易成功'],
    'TRADE_CLOSED': ['付款以后用户退款成功，交易自动关闭', '用户退款成功'],
    'TRADE_CLOSED_BY_TAOBAO': ['付款以前，卖家或买家主动关闭交易', '付款前关闭'],
    'PAY_PENDING': ['国际信用卡支付付款确认中', '付款确认中'],
    'WAIT_SELLER_AGREE': ['买家已经申请退款，等待卖家同意', '买家申请退款'],
    'WAIT_BUYER_RETURN_GOODS': ['卖家已经同意退款，等待买家退货', '卖家已同意退款'],
    'WAIT_SELLER_CONFIRM_GOODS': ['买家已经退货，等待卖家确认收货', '退货确认收货'],
    'SELLER_REFUSE_BUYER': ['卖家拒绝退款', '卖家拒绝退款'],
  };
  return states[str];
};
export const stateMF = (str) => {
  if (str === '' || str === undefined || str === null) {
    return ['', ''];
  }
  const states = {
    '1': ['待支付', '待出单'],
    '2': ['待出单', '待出单'],
    '3': ['', ''], // 空缺
    '4': ['已出单', '已出单'],
    '5': ['已完成', '已完成'],
    '6': ['已关闭', '已关闭'],
    '10': ['无退款', '无退款'],
    '11': ['未全部退款', '未全部退款'],
    '12': ['已全部退款', '已全部退款'],
    '20': ['可发起退款', '可发起退款'],
    '21': ['已完成退款', '已完成退款'],
    '22': ['已申请退款', '已申请退款'],
    '23': ['拒绝退款', '拒绝退款'],
    '24': ['已确认退款', '已确认退款'],
  };
  return states[str];
};

export const stateXC = (str) => {
  if (str === '' || str === undefined || str === null) {
    return ['', ''];
  }
  switch (str) {
    case 'XC_0':
      return ['未付款', '未付款'];
    case 'XC_1':
      return ['买家已付款', '买家已付款'];
    case 'XC_2':
      return ['部分付款', '部分付款'];
    case 'XC_3':
      return ['交易成功', '交易成功'];
    case 'XC_4':
      return ['关闭', '关闭'];
    default:
      return ['', ''];
  }
};

export const stateSYS = (str) => {
  if (str === '' || str === undefined || str === null) {
    return ['', ''];
  }
  switch (str) {
    case 'Z_0':
      return ['未付款', '未付款'];
    case 'Z_1':
      return ['买家已付款', '买家已付款'];
    case 'Z_2':
      return ['部分付款', '部分付款'];
    case 'Z_3':
      return ['交易成功', '交易成功'];
    case 'Z_4':
      return ['关闭', '关闭'];
    default:
      return ['', ''];
  }
};

export const getStatus = (str, pf_id, types = 1) => {
  let statuStr = '';
  switch (pf_id) {
    case 1:
      statuStr = stateTB(str);
      break;
    case 2:
      statuStr = stateMF(str);
      break;
    case 3:
      statuStr = stateXC(str);
      break;
    default:
      statuStr = '';
  }
  if (types === 2) {
    return stateSYS(str);
  }
  return statuStr || [];
};

export const getCommissionRate = (type) => {
  switch (type) {
    case 'F':
      return 0.051;
    case 'M':
      return 999;
    case 'X':
      return 888;
    default:
      return 0;
  }
};

export const wjIdToName = (id = 0) => {
  const box = {
    0: '未操作',
    1: '我加客人，客人没加我',
    2: '已加',
    3: '已建群',
  };
  return box[id];
};

export const actionEvent = (record, cb) => {
  // delete record.package;
  cb(record);
};

export const saveSearchCondition = (str = '') => {
  sessionStorage.setItem('order_search_condition', str);
};

export const clearSearchCondition = () => {
  sessionStorage.removeItem('order_search_condition');
};

export const readSearchCondition = (str) => {
  return sessionStorage.getItem('order_search_condition') || '';
};

export const decomposeTBOrders = (orders, addition = false) => {
  return orders;
};

export const procCalculateProfitMargin = (record, cb) => {
  if (record.orders_info[0].price === undefined) {
    record.orders_info[0].price = {
      adult_cost_price: 0,
      child_cost_price: 0,
      diff_cost_price: 0,
      exchange_rate: 0,
      currency_id: 0,
      insurance: 0,
      insurance_included: 0,
    };
  }
  const insurance_included = record.orders_info[0].insurance_included;
  const gear_p = parseInt(record.orders_info[0].gear_p || 1, 10);
  const gear_p_cost_price =
    gear_p !== 2 ? record.orders_info[0].price.adult_cost_price : record.orders_info[0].price.child_cost_price;
  const exchange_rate = record.exchange_rate || record.orders_info[0].price.exchange_rate || 1;
  record.exchange_rate = exchange_rate;
  let total_insurance = 0;
  if (insurance_included) {
    total_insurance = record.orders_info[0].num * record.orders_info[0].price.insurance;
  }
  let supplier_offer;
  let settlement_price;
  if (record.orders_info[0].is_supplier_offer_lock === 0) {
    if (!checkOrderType(record.orders_info[0])) {
      settlement_price = costCalculate(
        record.orders_info[0].price === undefined ? 0 : gear_p_cost_price,
        record.orders_info[0].num,
        record.orders_info[0].price === undefined ? 0 : record.orders_info[0].price.diff_cost_price
      );
      supplier_offer = (settlement_price * exchange_rate).toFixed(2);
      settlement_price = settlement_price.toFixed(2);
    } else {
      settlement_price = Number(record.orders_info[0].settlement_price || 0).toFixed(2);
      supplier_offer = (Number(settlement_price || 0) * exchange_rate).toFixed(2);
    }
  } else {
    settlement_price = Number(record.orders_info[0].settlement_price || 0).toFixed(2);
    supplier_offer = (Number(settlement_price || 0) * exchange_rate).toFixed(2);
  }
  /*mfw 状态12为全部退款,成本，结算都为0 */
  if (
    // ['TRADE_CLOSED_BY_TAOBAO', 'TRADE_CLOSED'].indexOf(record.orders_info[0].status_code) >= 0
    // || record.orders_info[0].status_code === '12'
    // || record.orders_info[0].status_code === '6'
    ['TRADE_CLOSED_BY_TAOBAO', 'TRADE_CLOSED', '12', 6].includes(record.orders_info[0].status_code)
  ) {
    settlement_price = 0;
    supplier_offer = 0;
    total_insurance = 0;
  }
  let price = webSettlementCalculate(
    record.orders_info[0].transaction_amount,
    supplier_offer,
    record.orders_info[0].commission_rate,
    total_insurance
  );
  // console.log(price, total_insurance);
  console.log(record.orders_info[0].transaction_amount, supplier_offer, record.orders_info[0].commission_rate);
  console.log(
    supplier_offer,
    price,
    `${record.orders_info[0].transaction_amount} - (${record.orders_info[0].transaction_amount} * ${record.orders_info[0].commission_rate}) - ${record.orders_info[0].supplier_offer} * ${record.orders_info[0].num} = ${price}`
  );
  cb(null, price, supplier_offer, settlement_price, total_insurance);
};

export const gProcCalculateProfitMargin = (record, cb) => {
  console.log('gProcCalculateProfitMargin', record);
  record = { ...record };
  if (record.current_suppliers === undefined) {
    record.current_suppliers = { supplier_offer: 0 };
  }
  if (record.current_suppliers.price === undefined) {
    record.current_suppliers.price = {
      adult_cost_price: 0,
      child_cost_price: 0,
      diff_cost_price: 0,
      // exchange_rate: 0,
      // currency_id: 0,
      // insurance: 0,
      // insurance_included: 0,
    };
  }
  const insurance_included = record.insurance_included;
  const gear_p = parseInt(record.gear_p || 1, 10);
  const exchange_rate =
    record.exchange_rate || mapper.getKeyValue(record, 'current_suppliers.price.exchange_rate') || 1;
  const supplier_tax_point = +(mapper.getKeyValue(record, 'current_suppliers.tax_point') || 0);
  let supplier_tax = 0;
  let gear_p_cost_price = 0;
  gear_p_cost_price =
    gear_p !== 2 ? record.current_suppliers.price.adult_cost_price : record.current_suppliers.price.child_cost_price;
  gear_p_cost_price = gear_p_cost_price === 0 ? record.settlement_price : gear_p_cost_price;
  record.exchange_rate = exchange_rate;
  let total_insurance = 0;
  // total_insurance = record.total_insurance;

  // if (insurance_included===1) {
  total_insurance = record.total_insurance; // record.num * record.total_insurance;
  // }else{
  //   total_insurance = 0 // test !!!!!!!!未完成
  // }
  let supplier_offer;
  let settlement_price;
  if (record.is_supplier_offer_lock === 0) {
    if (!checkOrderType(record)) {
      settlement_price = costCalculate(gear_p_cost_price, record.num, record.current_suppliers.price.diff_cost_price);
      console.log(`${!checkOrderType(record)}`, 1);
      supplier_offer = truncate(calc(`${settlement_price} * ${exchange_rate}`), 2);
      settlement_price = truncate(settlement_price, 2);
      console.log(
        1,
        `${Number(settlement_price || 0)} * ${exchange_rate}`,
        Number(settlement_price || 0) * exchange_rate
      );
    } else {
      console.log(`${!checkOrderType(record)}`, 2);
      settlement_price = truncate(Number(record.settlement_price || 0), 2);
      supplier_offer = truncate(calc(`${bNumber(settlement_price || 0)} * ${exchange_rate}`), 2);
      console.log(
        2,
        `${Number(settlement_price || 0)} * ${exchange_rate}`,
        Number(settlement_price || 0) * exchange_rate
      );
    }
  } else {
    settlement_price = truncate(Number(record.settlement_price || 0), 2);
    supplier_offer = truncate(calc(`${bNumber(settlement_price || 0)} * ${exchange_rate}`), 2);
  }
  console.log('成本', settlement_price, supplier_offer, record.settlement_price);
  // 计算税额（总税额）
  // console.log(settlement_price, Number(settlement_price) + (supplier_tax * exchange_rate));
  // console.log(supplier_offer, Number(supplier_offer) + supplier_tax);
  supplier_tax = Number(settlement_price) * supplier_tax_point;
  /*mfw 状态12为全部退款,成本，结算都为0 */
  // console.log(11111111111, record.status_code);
  // if (
  //   ['TRADE_CLOSED_BY_TAOBAO', 'TRADE_CLOSED', '12', 6].includes(record.status_code)
  // ) {
  // settlement_price = 0;
  // supplier_offer = 0;
  // total_insurance = 0;
  // }
  let price = webSettlementCalculate(
    record.transaction_amount,
    supplier_offer,
    record.commission_rate,
    total_insurance
  );
  // console.log(price, record.transaction_amount, supplier_offer, record.commission_rate, total_insurance);
  console.log(
    `profit ${record.transaction_amount} - (${record.transaction_amount} * ${record.commission_rate}) - ${record.current_suppliers.supplier_offer} * ${record.num} * ${supplier_tax_point} = ${price}`
  );
  cb(null, price, supplier_offer, settlement_price, total_insurance, supplier_tax);
};

export const priceCombination = () => {};
/**
 * 是否是自建订单且未填写产品SKU_Code
 */
export const checkOrderType = (info) => {
  if (info.sku_code === '' && info.order_types === 2) {
    return true;
  }
  return false;
};

export const mergeOrderInfo = (orders) => {
  console.log('merge', orders);

  return (orders[0].orders_info = orders.reduce((previousValue, currentValue) => {
    previousValue.push(currentValue.orders_info[0]);
    return previousValue;
  }, []));
};

export const wrapOrdersEdit = (obj) => {
  const orders = obj.orders;
  console.log('obj.orders', obj.orders);
  orders.changed_by_id = obj.orders.changed_by_id;
  orders.orders_info = orders.orders_info.map((info) => {
    if (info.order_types === 2) {
      info.payment = info.transaction_amount;
    }
    if (info.oi_id.toString().substr(0, 5) === 'oi_id') {
      info.oi_id = null;
    }
    return info;
  });
  orders.traveller = orders.traveller.map((t) => {
    if (String(t.ori_id).substr(0, 6) === 'ori_id') {
      t.ori_id = null;
    }
    return t;
  });
  orders.payment = orders.payment.map((t) => {
    if (String(t.obt_id).substr(0, 6) === 'obt_id') {
      t.obt_id = null;
    }
    return t;
  });
  orders.transaction_amount = orders.orders_info.reduce((previousValue, currentValue) => {
    return (parseFloat(previousValue) || 0) + (parseFloat(currentValue.transaction_amount) || 0);
  }, 0);
  return orders;
};

export const webSourceToObject = (ws) => {
  switch (ws) {
    case 'F':
      return { key: 'F', label: '飞猪' };
    case 'M':
      return { key: 'M', label: '蚂蜂窝' };
    case 'X':
      return { key: 'X', label: '携程' };
    default:
      return [];
  }
};

export const webSourceToNumber = (ws) => {
  const r = {
    'F': 1,
    'M': 2,
    'X': 3,
  };
  return r[ws] || 1;
};

/**
 * @deprecated
 */
export const shops = {
  '1': 'F 桂林中国国旅专营店',
  '5': 'LF 柳分',
  '7': 'NF 南分',
  // '8': '美国fuda',
  '9': 'DF 第5季',
  '2': 'M 第5季自由行',
  '4': 'DM 第5季旅游',
  '3': 'HCM 旅行家',
  '6': 'HCF 华成国旅',
  '10': 'DM 野猫旅行',
  '12': 'XC 国旅携程（跟团）',
  '13': 'XC 国旅携程（玩乐）',
  '31': 'HCMT 华成美团',
  '32': 'TN 国旅途牛',
  '33': 'XC 国旅携程',
  '34': 'L 国旅驴妈妈',
  '35': 'C 塞班sunny',
  '36': 'DX 第五季携程',
  '37': 'DQ 第五季去哪儿',
  '38': 'XC 第五季携程酒店',
  '39': 'DDY 第五季抖音',
  '40': 'DXHS 第五季小红书',
  '41': 'TC 同程',
  '42': 'DFX 第五季分销',
  '43': 'DXXSK 第五季线下收客',
  '0': '-',
};

/**
 * @ignore 没用
 * @deprecated
 */
export const shopsCode = {
  '0': 'XX',
  '1': 'F',
  '5': 'LF',
  '7': 'NF',
  '8': '',
  '9': 'DF',
  '2': 'M',
  '4': '',
  '3': 'HCM',
  '6': 'HCF',
  '10': 'DM',
  '12': 'XC',
  '13': 'XC',
  '31': 'HCMT',
  '32': 'TN',
  '33': 'XC',
  '34': 'L',
  '35': 'C',
  '36': 'DX',
  '37': 'DQ',
  '38': 'XC',
  '39': 'DDY', // 第五季抖音
  '40': 'DXHS', // 第五季小红书
  '41': 'TC',
  '42': 'DFX',
  '43': 'DXXSK',
};

/**
 * @deprecated 从数据库取
 */
export const platformShop = [
  {
    key: '1',
    label: '飞猪',
    shop: [
      { key: '1', label: 'F 桂林中国国旅专营店', code: 'F' },
      { key: '5', label: 'LF 柳分', code: 'LF' },
      { key: '7', label: 'NF 南分', code: 'NF' },
      { key: '9', label: 'DF 第5季', code: 'DF' },
      { key: '6', label: 'HCF 华成国旅', code: 'HCF' },
      { key: '35', label: 'C 塞班sunny', code: 'C' },
    ],
  },
  {
    key: '2',
    label: '蚂蜂窝',
    shop: [
      { key: '2', label: 'M 第5季自由行', code: 'M' },
      { key: '4', label: 'DM 第5季旅游', code: 'DM' },
      { key: '3', label: 'HCM 旅行家', code: 'HCM' },
      { key: '10', label: 'DM 野猫旅行', code: 'DM', status: 0 },
    ],
  },
  {
    key: '3',
    label: '携程',
    shop: [
      { key: '12', label: 'XC 国旅携程（跟团）', code: 'X' },
      { key: '13', label: 'XC 国旅携程（玩乐）', code: 'X' },
      { key: '33', label: 'XC 国旅携程', code: 'X', status: 0 },
      { key: '36', label: 'DX 第五季携程', code: 'DX' },
      { key: '38', label: 'XC 第五季携程酒店', code: 'X', status: 0 },
      { 'key': '51', 'label': 'JD酒店代理-趣耍', 'code': 'X' },
      { 'key': '52', 'label': 'JD酒店代理-国旅', 'code': 'X' },
    ],
  },
  {
    key: '4',
    label: '美团',
    shop: [{ key: '31', label: 'HCMT 华成美团', code: 'HCMT' }],
  },
  {
    key: '5',
    label: '途牛',
    shop: [{ key: '32', label: 'TN 国旅途牛', code: 'TN' }],
  },
  {
    key: '6',
    label: '驴妈妈',
    shop: [{ key: '34', label: 'L 国旅驴妈妈', code: 'L' }],
  },
  {
    key: '7',
    label: '去哪儿',
    shop: [{ key: '37', label: 'DQ 第五季去哪儿', code: 'DQ' }],
  },
  {
    key: '9',
    label: '同程',
    shop: [{ key: '41', label: 'TC 华成同程', code: 'TC' }],
  },
  {
    key: '8',
    label: '社媒',
    shop: [
      { key: '39', label: 'DDY 第五季抖音', code: 'DDY' },
      { key: '40', label: 'DXHS 第五季小红书', code: 'DXHS' },
      { key: '53', label: 'DYM 抖音服务商', code: 'DYM' },
      { key: '54', label: 'HCDY 抖音趣耍旅行社', code: 'HCDY' },
      { key: '55', label: 'DYP 抖音推广费', code: 'DYP' },
    ],
  },
  {
    key: '10',
    label: '第五季线下分销',
    shop: [
      { 'key': '44', 'label': '01', 'code': 'LTT' },
      { 'key': '45', 'label': '02', 'code': 'YA' },
      { 'key': '46', 'label': '03', 'code': 'YY' },
      { 'key': '47', 'label': '04', 'code': 'MG' },
      { 'key': '50', 'label': '05', 'code': 'ZRF' },
      { 'key': '56', 'label': '06', 'code': 'JS' },
      { 'key': '57', 'label': '07', 'code': 'CITS' },
      { 'key': '66', 'label': '惠州青年', 'code': 'HZQN' },
      { key: '42', label: 'DFX 第五季分销', code: 'DFX', status: 0 },
    ],
  },
  {
    key: '11',
    label: '第五季线下收客',
    shop: [
      { key: '43', label: 'DXXSK 第五季线下收客', code: 'DXXSK' },
      { key: '48', label: '线下收客-刘玉翠', code: 'LYC' },
      { key: '49', label: '线下收客-陶淑呈', code: 'TSC' },
    ],
  },
  {
    key: '0',
    label: '其它',
    shop: [{ key: '0', label: '-', code: 'QT' }],
  },
];

export const tradeChannels = [
  { key: 0, label: '支付宝' },
  { key: 1, label: '微信支付' },
  { key: 2, label: '银行' },
  { key: 3, label: '电汇' },
  { key: 4, label: '现金' },
  { key: 5, label: '平台收款' },
];
export const balanceTypes = [
  { key: 0, label: '业务调账' },
  { key: 1, label: '程序调账' },
  { key: 2, label: '财务人工调账' },
  { key: 3, label: '财务程序调账（对账）' },
];

export const branchOffice = [
  { 'key': 288, 'label': '桂林中国国际旅行社有限责任公司' },
  { 'key': 978, 'label': '广西第五季旅游有限公司' },
  { 'key': 984, 'label': '广西趣耍旅行服务有限公司' },
];

export const auxAccounting = [
  // { 'key': '130', 'label': '境外事业部' },
  // { 'key': '131', 'label': '第五季境外事业部' },
  // { 'key': '140', 'label': '境内事业部' },
  // { 'key': '150', 'label': '网站事业部' },
  // { 'key': '160', 'label': '第五季综合' },
  { 'key': '131', 'label': '境外' },
  { 'key': '140', 'label': '境内' },
  // { 'key': '150', 'label': '国际部' },
  // { 'key': '190', 'label': '定制中心' },
  { 'key': '170', 'label': '国旅境内' },
];

export const cloudpenseAuxAccounting = [
  { 'key': 288, 'label': '桂林中国国际旅行社有限责任公司' },
  { 'key': 978, 'label': '广西第五季旅游有限公司' },
  { 'key': 984, 'label': '广西趣耍旅行服务有限公司' },
];

export const defaultSearchStatus = [
  { key: '2', value: '2' },
  { key: '4', value: '4' },
  { key: '5', value: '5' },
  { key: 'WAIT_SELLER_SEND_GOODS', value: 'WAIT_SELLER_SEND_GOODS' },
  { key: 'TRADE_FINISHED', value: 'TRADE_FINISHED' },
  { key: 'WAIT_BUYER_CONFIRM_GOODS', value: 'WAIT_BUYER_CONFIRM_GOODS' },
  { key: 'Z_1', value: 'Z_1' },
  { key: 'Z_3', value: 'Z_3' },
  { key: 'XC_1', value: 'XC_1' },
  { key: 'XC_2', value: 'XC_2' },
  { key: 'XC_3', value: 'XC_3' },
  { key: 'DYLK_200', value: 'DYLK_200' },
  { key: 'DYLK_201', value: 'DYLK_201' },
  { key: 'DYLK_1', value: 'DYLK_1' },
];

export const ordersStatusPayed = [].concat(defaultSearchStatus, [
  { key: 'TRADE_CLOSED', value: 'TRADE_CLOSED' },
  { key: 'XC_4', value: 'XC_4' },
  { key: 'DYLK_101', value: 'DYLK_101' },
  { key: '6', value: '6' },
]);

export const requirePaymentTypes = [
  {
    value: '0',
    label: '借款',
    data: [
      { value: 'loans', label: '个人借款 - 申请', empty_new: true, create_by_biz: true },
      { value: 'writeloans', label: '付款（使用个人借款）', empty_new: true, create_by_biz: true },
      { value: 'refundloans', label: '退余额', empty_new: false, create_by_biz: true },
    ],
  },
  {
    value: '1',
    label: '预付款',
    data: [
      { value: 'prepay', label: '预付款 - 申请', empty_new: true, create_by_biz: true },
      { value: 'writepay', label: '付款（使用预付款）', empty_new: true, create_by_biz: true },
      { value: 'offlineinvoice', label: '线下销账补单', empty_new: false, create_by_biz: false },
    ],
  },
  {
    value: '2',
    label: '付款',
    data: [
      { value: 'pay', label: '付款（直接转账）', empty_new: true, create_by_biz: true },
      { value: 'refund', label: '退款单', empty_new: true, create_by_biz: true },
    ],
  },
];

export const clickFarms = [
  { 'key': '', 'label': ' 全部 ', value: '' },
  { 'key': 0, 'label': ' 否 ', value: 0 },
  { 'key': 1, 'label': ' 是 ', value: 1 },
];

export const groupTypes = [
  // { 'key': '', 'label': ' 全部 ', value: '', },
  { 'key': 0, 'label': ' OTA ', value: 0 },
  { 'key': 1, 'label': ' 地接组团 ', value: 1 },
];
